import React, {useState, useEffect, useRef, Fragment,Suspense} from 'react';

import {
    Table, Col, Row, Card, CardBody,
    CardTitle, Button, Label, Input,FormGroup
} from 'reactstrap';

import Parametri from '../parametri';
import Clessidra from './Clessidra.js';
import TrasformaDateAUmano from './TrasformaDateAUmano.js';
import LinearProgressWithLabel, { LinearProgressProps } from '@material-ui/core/LinearProgress';
import Modale from './Modale.js';
//import TabellaFaq from './TabellaFaq/Tabella';

const STATO_INDEFINITO = 0;
const STATO_MEMORIZZAZIONE = 1;
const STATO_ERRORE_CONNESSIONE = 2;
const STATO_OPERAZIONE_FALLITA = 3;
const STATO_RICERCA_DATI_CORRETTA = 4;
//const STATO_VAI_IN_FAQ = 5;

function Home(props) {

    const [flagDatiDocumenti, setFlagDatiDocumenti] = useState(false);
    const [flagDatiAdempimenti, setFlagDatiAdempimenti] = useState(false);
    const [flagDatiAzioniCRM, setFlagDatiAzioniCRM] = useState(false);
    const [flagDatiPagamenti, setFlagDatiPagamenti] = useState(false);
    const [dimensioneDatabaseMB, setDimensioneDatabaseMB] = useState(0);
    const [dimensioneAllegatiMB, setDimensioneAllegatiMB] = useState(0);
    const [numeroIscritti, setNumeroIscritti] = useState(-1);
    const [documentiCertScaduti, setDocumentiCertScaduti] = useState(0);
    const [documentiCertScadenza, setDocumentiCertScadenza] = useState(0);
    const [documentiDocIdScaduti, setDocumentiDocIdScaduti] = useState(0);
    const [documentiDocIdScadenza, setDocumentiDocIdScadenza] = useState(0);
    const [documentiPrivacyScaduti, setDocumentiPrivacyScaduti] = useState(0);
    const [documentiPrivacyScadenza, setDocumentiPrivacyScadenza] = useState(0);
    const [adempimentiScaduti, setAdempimentiScaduti] = useState(0);
    const [adempimentiScadenza, setAdempimentiScadenza] = useState(0);
    const [azioniCRMScaduti, setAzioniCRMScaduti] = useState(0);
    const [azioniCRMScadenza, setAzioniCRMScadenza] = useState(0);
    const [numSpesePagare, setNumSpesePagare] = useState(0);
    const [numRimborsiPagare, setNumRimborsiPagare] = useState(0);
    const [giorniValiditaAbbonamento, setGiorniValiditaAbbonamento] = useState(0);
    const [limiteMB, setLimiteMB] = useState(0);
    const [limiteIscritti, setLimiteIscritti] = useState(0);
    const [formAiuto, setFormAiuto] = useState(false);
    const [problemaNonSpecificato, setProblemaNonSpecificato] = useState(false);
    const [richiestaAiutoFallita, setRichiestaAiutoFallita] = useState(false);
    const [richiestaAiutoInviata, setRichiestaAiutoInviata] = useState(false);
    const [mailRichiedenteAiuto,setMailRichiedenteAiuto]=useState('');
    const [suggerimenti, setSuggerimenti] = useState([]);
    const [loading,setLoading]= useState(false);
    const [statoPagina,setStatoPagina]=useState(STATO_INDEFINITO);
    const [error,setError]=useState('');

    const [recuperatiDatiCreditoriEInsolventi,setRecuperatiDatiCreditoriEInsolventi]= useState(false);
    const [numeroInsolventiTot,setNumeroInsolventiTot]=useState(0);
    const [numeroCreditoriTot,setNumeroCreditoriTot]=useState(0);
    const [numeroInsolventiQAss,setNumeroInsolventiQAss]=useState(0);
    const [numeroCreditoriQAss,setNumeroCreditoriQAss]=useState(0);
    const [numeroInsolventiQAbb,setNumeroInsolventiQAbb]=useState(0);
    const [numeroCreditoriQAbb,setNumeroCreditoriQAbb]=useState(0);
    const [certificatiDaVerificare, setCertificatiDaVerificare] = useState(0);
    const [documentiDaVerificare, setDocumentiDaVerificare] = useState(0);

    const problema   = useRef();

    useEffect(() => {
        scaricaDati();
        
    },[]);

    useEffect(() => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"reportInsolventi", soloPerSpecchiettoInHome:1,emak:props.emak, sessionId: props.sessionId})
          };
          fetch(Parametri("serverURL", props.identitaSelezionata), requestOptions)
          .then(risposta => risposta.json())
          .then(
          (valoreDiRitorno) => {          
              if(valoreDiRitorno.risultatoOperazione===1){
                setRecuperatiDatiCreditoriEInsolventi(true);
                setNumeroInsolventiTot(valoreDiRitorno.risultatoRitorno[0].INSOLVENTI_TOT);
                setNumeroCreditoriTot(valoreDiRitorno.risultatoRitorno[0].CREDITORI_TOT);
                setNumeroInsolventiQAss(valoreDiRitorno.risultatoRitorno[0].INSOLVENTI_Q_ASS);
                setNumeroCreditoriQAss(valoreDiRitorno.risultatoRitorno[0].CREDITORI_Q_ASS);
                setNumeroInsolventiQAbb(valoreDiRitorno.risultatoRitorno[0].INSOLVENTI_Q_ABB);
                setNumeroCreditoriQAbb(valoreDiRitorno.risultatoRitorno[0].CREDITORI_Q_ABB);   
              }
              if(valoreDiRitorno.risultatoOperazione===2) {
                  //console.log("errore scaricamento dati creditori e insolventi da " + Parametri("serverURL",props.identitaSelezionata));
                  props.setPagina(props.PAGINE.tornaLogin);
              }
        },
        (error) => {console.log("Errore fetch creditori insolventi");}
      );        
    }, []);

    
    function Elenco(props) {
        return (
            <>
                {props.elementi.map((elemento,indice) => 
                    <div key={indice} style={{border:"0.5px solid #d0d0d0", backgroundColor:indice%2===0?"#fcfcfc":"f0f0f0"}}>{elemento}</div>
                )}
            </>
        ) 
    }

    function HomeCard({
        titolo,
        children,
        attenzione=false,
        testoAttenzione="",
        className=""
    }) {
        return (
            <div className={`homeCard ${className}`}>
                <div className="homeCardTitolo">
                    <span>{titolo}</span>
                    {attenzione &&
                        <span className="homeCardAttenzione">
                            {testoAttenzione || "Attenzione"}
                        </span>
                    }
                </div>
                <div className="homeCardContenuto">
                    {children}
                </div>

            </div>
        );
    }

    function HomeVoce({
        titolo,
        valore,
        stato="normale",
        sottotitolo="",
        onClick=null
    }) {
        return (
            <div
                className={`homeVoce ${onClick ? "homeVoceCliccabile" : ""}`}
                onClick={onClick || undefined}
            >
                <div className="homeVoceTesto">
                    <div className="homeVoceTitolo">{titolo}</div>

                    {sottotitolo !== "" &&
                        <div className="homeVoceSottotitolo">
                            {sottotitolo}
                        </div>
                    }
                </div>

                {valore !== undefined && valore !== null &&
                    <div className={`homeBadge homeBadge-${stato}`}>
                        {valore}
                    </div>
                }
            </div>
        );
    }    

    function Benvenuto(props) {

        const spazioUtilizzato =
            dimensioneDatabaseMB + dimensioneAllegatiMB;

        const percentualeIscritti =
            limiteIscritti > 0
                ? Math.min(100, numeroIscritti * 100 / limiteIscritti)
                : 0;

        const percentualeSpazio =
            limiteMB > 0
                ? Math.min(100, spazioUtilizzato * 100 / limiteMB)
                : 0;

        let ruolo = "";

        if (
            props.identitaSelezionata.flag_staff &&
            props.identitaSelezionata.flag_amministrazione
        ) {
            ruolo = "Amministrazione e staff";
        } else if (props.identitaSelezionata.flag_amministrazione) {
            ruolo = "Amministrazione";
        } else if (props.identitaSelezionata.flag_staff) {
            ruolo = "Staff";
        }     

        return (
            <div className="homeCard homeBenvenutoCompatto">

                <div className="homeBenvenutoPersona">
                    <div className="homeBenvenutoTitolo">
                        Buongiorno, {props.identitaSelezionata.nome}
                    </div>

                    <div className="homeBenvenutoRuolo">
                        Accesso: {ruolo}
                    </div>

                    <div className="homeBenvenutoNotifiche">
                        Notifiche {props.token !== "" ? "Attive" : "Non attive"}
                    </div>                                      

                </div>

                <div className="homeMiniStats">

                    <div className="homeMiniStat">
                        <div className="homeMiniStatLabel">
                            Iscritti
                        </div>

                        <div className="homeMiniStatValore">
                            {numeroIscritti} / {limiteIscritti}
                        </div>

                        <div className="homeProgress">
                            <div
                                className="homeProgressBar"
                                style={{width:`${percentualeIscritti}%`}}
                            />
                        </div>
                    </div>


                    <div className="homeMiniStat">
                        <div className="homeMiniStatLabel">
                            Spazio
                        </div>

                        <div className="homeMiniStatValore">
                            {spazioUtilizzato} / {limiteMB} MB
                        </div>

                        <div className="homeProgress">
                            <div
                                className="homeProgressBar"
                                style={{width:`${percentualeSpazio}%`}}
                            />
                        </div>
                    </div>                                    
                
                </div>                                
            </div>
        );
    }

    function AlertAbbonamentoScaduto() {

        const g = giorniValiditaAbbonamento;

        let msg = "";
        let classe = "homeCardAbbonamentoScaduto ";
        let extra = "";

        if (g < 30) {
            // testo principale
            if (g > 1) {
                msg = `Il tuo Gestione Sportiva scade tra ${g} giorni.`;
                classe += "evidenziatoAvviso";
            } else if (g === 1) {
                msg = "Il tuo Gestione Sportiva scade domani.";
                classe += "evidenziatoAvviso";
            } else if (g === 0) {
                msg = "Il tuo Gestione Sportiva scade oggi.";
                classe += "evidenziatoAllarme";
            } else if (g === -1) {
                msg = "Il tuo Gestione Sportiva è scaduto ieri.";
                classe += "evidenziatoAllarme";
            } else {
                msg = `Il tuo Gestione Sportiva è scaduto da ${-g} giorni.`;
                classe += "evidenziatoAllarme";
            }

            // riga extra SOLO se scaduto da più di 14 giorni
            // (messaggio credibile: non promette cancellazione certa e immediata)
            if (g <= -15) {
                extra = "I dati di abbonamenti e prove gratuite scaduti da oltre 2 settimane possono essere soggetti a rimozione automatica senza ulteriore preavviso.";
            }
        }
        
        if (msg == "") return null;

        return (
            <div className={classe}>
                <b>
                {msg}<br/>
                Vai su{" "}
                <span
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => { props.setPagina(props.PAGINE.mioAbbonamento)
                    }}
                >
                    Impostazioni → Mio Abbonamento
                </span>{" "}
                o contatta <a style={{color:"inherit", textDecoration: "underline"}} href="mailto:assistenza@gestionesportiva.it">assistenza@gestionesportiva.it</a> per rinnovare.
                {extra ? (
                    <>
                    <br />
                    <span style={{ fontWeight: "normal" }}>{extra}</span>
                    </>
                ) : null}
                </b>
            </div>
        )
    }

    function Aiuto(props) {

        return (
            <HomeCard titolo="Aiuto">

                <div className="homeAiutoBottoni">

                    <button
                        className='homeBottone'
                        onClick={() =>
                            props.setPagina(props.PAGINE.faq)
                        }
                    >
                        Domande frequenti
                    </button>

                    <button
                        className='homeBottone'
                        onClick={() => setFormAiuto(true)}
                    >
                        Richiesta di assistenza
                    </button>

                </div>


                {suggerimenti.length > 0 &&
                    <div className="homeSuggerimenti">

                        <div className="homeSuggerimentiTitolo">
                            Suggerimenti
                        </div>

                        {suggerimenti.map((elemento, indice) =>
                            <div
                                key={indice}
                                className={
                                    elemento.paginaRichiamata !== ""
                                        ? "homeSuggerimento homeSuggerimentoCliccabile"
                                        : "homeSuggerimento"
                                }
                                onClick={() => {
                                    if (elemento.paginaRichiamata !== "") {
                                        props.setPagina(elemento.paginaRichiamata);
                                    }
                                }}
                            >
                                {elemento.descrizione}
                            </div>
                        )}

                    </div>
                }

            </HomeCard>
        );
    }

    function tornaHome() {
        setFormAiuto(false);
        setProblemaNonSpecificato(false);
        setRichiestaAiutoFallita(false);
        setRichiestaAiutoInviata(false);
    }
    function fetchRichiestaAiuto() {

        let controlli=0;

       //controllo preventivamente i campi:
        if(problema.current.value===''){
            controlli = 1;
            setProblemaNonSpecificato(true);
        }

        if(controlli===0){   
            // parametri per inviare i dati al server:
            setLoading(true);
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: 
                JSON.stringify({op:"richiestaAiuto",
                    problema:problema.current.value,
                    societa:props.identitaSelezionata.societa,
                    emak: props.emak,
                    sessionId:props.sessionId
                })
            };
            
            setStatoPagina(STATO_MEMORIZZAZIONE);

            fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
                .then(risposta => risposta.json())
                .then(
                (valoreDiRitorno) => {
                    setLoading(false);
                    if(valoreDiRitorno.risultatoOperazione===1) {
                        //messaggio che la richiesta è stata inoltrata correttamente e di attendere risposta tramite mail
                        setMailRichiedenteAiuto(valoreDiRitorno.mailRichiedente);
                        setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
                        setRichiestaAiutoInviata(true);
                    }
                    if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                    if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                        if(valoreDiRitorno.mess !== undefined){
                            if(valoreDiRitorno.mess.indexOf("Richiesta di aiuto fallita") !== -1){
                                setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
                                setRichiestaAiutoFallita(true);
                            } 
                        }
                        //altrimenti vado in errore generico
                        setStatoPagina(STATO_OPERAZIONE_FALLITA);
                    } 
                },
                (error) => {setLoading(false);setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            );
        }
    }

    function DocumentiScadenze(props) {

        if (!flagDatiDocumenti) {
            return (
                <HomeCard titolo="Documenti degli iscritti">
                    <Clessidra loading={true}/>
                </HomeCard>
            );
        }


        const numProblemiDocumenti =
            (documentiCertScaduti > 0 ? 1 : 0) +
            (certificatiDaVerificare > 0 ? 1 : 0) +
            (documentiDocIdScaduti > 0 ? 1 : 0) +
            (documentiDaVerificare > 0 ? 1 : 0) +
            (documentiPrivacyScaduti > 0 ? 1 : 0);

        return (
            <HomeCard 
                titolo="Documenti degli iscritti"
                attenzione={numProblemiDocumenti > 0}
                testoAttenzione={`${numProblemiDocumenti} criticità`}
            >

                <HomeVoce
                    titolo="Certificati medici"
                    valore={documentiCertScaduti}
                    stato={documentiCertScaduti > 0 ? "allarme" : "ok"}
                    sottotitolo={
                        documentiCertScaduti > 0
                            ? `${documentiCertScaduti} scaduti o mancanti`
                            : "Nessun certificato scaduto o mancante"
                    }
                    onClick={() =>
                        props.setPagina(props.PAGINE.certScad)
                    }
                />

                {documentiCertScadenza > 0 &&
                    <HomeVoce
                        titolo="Certificati in scadenza"
                        valore={documentiCertScadenza}
                        stato="avviso"
                        sottotitolo="Entro un mese"
                        onClick={() =>
                            props.setPagina(props.PAGINE.certScad)
                        }
                    />
                }

                {certificatiDaVerificare > 0 &&
                    <HomeVoce
                        titolo="Certificati medici da verificare"
                        valore={certificatiDaVerificare}
                        stato="avviso"
                        sottotitolo="Caricati dagli iscritti e in attesa di verifica"
                        onClick={() =>
                            props.setPagina(props.PAGINE.certificatiDaVerificare)
                        }
                    />
                }

                <HomeVoce
                    titolo="Documenti d'identità"
                    valore={documentiDocIdScaduti}
                    stato={documentiDocIdScaduti > 0 ? "allarme" : "ok"}
                    sottotitolo={
                        documentiDocIdScaduti > 0
                            ? `${documentiDocIdScaduti} scaduti o mancanti`
                            : "Nessun documento scaduto o mancante"
                    }
                    onClick={() =>
                        props.setPagina(props.PAGINE.docScad)
                    }
                />

                {documentiDocIdScadenza > 0 &&
                    <HomeVoce
                        titolo="Documenti d'identità in scadenza"
                        valore={documentiDocIdScadenza}
                        stato="avviso"
                        sottotitolo="Entro un mese"
                        onClick={() =>
                            props.setPagina(props.PAGINE.docScad)
                        }
                    />
                }

                {documentiDaVerificare > 0 &&
                    <HomeVoce
                        titolo="Documenti da verificare"
                        valore={documentiDaVerificare}
                        stato="avviso"
                        sottotitolo="In attesa di verifica"
                        onClick={() =>
                            props.setPagina(props.PAGINE.documentiDaVerificare)
                        }
                    />
                }

                <HomeVoce
                    titolo="Privacy"
                    valore={documentiPrivacyScaduti}
                    stato={documentiPrivacyScaduti > 0 ? "allarme" : "ok"}
                    sottotitolo={
                        documentiPrivacyScaduti > 0
                            ? `${documentiPrivacyScaduti} mancanti o scaduti`
                            : "Documentazione regolare"
                    }
                    onClick={() =>
                        props.setPagina(props.PAGINE.privacyScad)
                    }
                />

                {documentiPrivacyScadenza > 0 &&
                    <HomeVoce
                        titolo="Privacy in scadenza"
                        valore={documentiPrivacyScadenza}
                        stato="avviso"
                        sottotitolo="Entro un mese"
                        onClick={() =>
                            props.setPagina(props.PAGINE.privacyScad)
                        }
                    />
                }                

            </HomeCard>
        );
    }

    function AdempimentiScadenze(props) {

        const numProblemiAdempimenti =
            (adempimentiScaduti > 0 ? 1 : 0) +
            (azioniCRMScaduti > 0 ? 1 : 0);

        return (
            <HomeCard 
                titolo="Adempimenti e CRM"
                attenzione={numProblemiAdempimenti > 0}
                testoAttenzione={`${numProblemiAdempimenti} criticità`}
            >

                {flagDatiAdempimenti ?
                    <>
                        <HomeVoce
                            titolo="Adempimenti scaduti"
                            valore={adempimentiScaduti}
                            stato={adempimentiScaduti > 0 ? "allarme" : "ok"}
                            sottotitolo={
                                adempimentiScaduti > 0
                                    ? "Richiedono attenzione"
                                    : "Nessun adempimento scaduto"
                            }
                            onClick={() =>
                                props.setPagina(props.PAGINE.scadenziario)
                            }
                        />

                        {adempimentiScadenza > 0 &&
                            <HomeVoce
                                titolo="Adempimenti in scadenza"
                                valore={adempimentiScadenza}
                                stato="avviso"
                                sottotitolo="Entro un mese"
                                onClick={() =>
                                    props.setPagina(props.PAGINE.scadenziario)
                                }
                            />
                        }
                    </>
                :
                    <Clessidra loading={true}/>
                }


                {flagDatiAzioniCRM ?
                    <>
                        <HomeVoce
                            titolo="Azioni CRM scadute"
                            valore={azioniCRMScaduti}
                            stato={azioniCRMScaduti > 0 ? "allarme" : "ok"}
                            sottotitolo={
                                azioniCRMScaduti > 0
                                    ? "Azioni non ancora completate"
                                    : "Nessuna azione scaduta"
                            }
                            onClick={() =>
                                props.setPagina(props.PAGINE.reportAzioniCrm)
                            }
                        />

                        {azioniCRMScadenza > 0 &&
                            <HomeVoce
                                titolo="Azioni CRM in scadenza"
                                valore={azioniCRMScadenza}
                                stato="avviso"
                                sottotitolo="Entro un mese"
                                onClick={() =>
                                    props.setPagina(props.PAGINE.reportAzioniCrm)
                                }
                            />
                        }
                    </>
                :
                    <Clessidra loading={true}/>
                }

            </HomeCard>
        );
    }

    function PagamentiScadenze(props) {

        return (
            <HomeCard titolo="Pagamenti">

                {!flagDatiPagamenti ?
                    <Clessidra loading={true}/>
                :
                    <>
                        <HomeVoce
                            titolo="Spese da pagare"
                            valore={numSpesePagare}
                            stato={numSpesePagare > 0 ? "avviso" : "ok"}
                            onClick={() =>
                                props.setPagina(props.PAGINE.spese)
                            }
                        />

                        <HomeVoce
                            titolo="Rimborsi da pagare"
                            valore={numRimborsiPagare}
                            stato={numRimborsiPagare > 0 ? "avviso" : "ok"}
                            onClick={() =>
                                props.setPagina(props.PAGINE.rimborsi)
                            }
                        />
                    </>
                }

                {recuperatiDatiCreditoriEInsolventi === false ?
                    <div className="homeVoceSottotitolo" style={{padding:"8px 4px"}}>
                        Calcolo creditori e insolventi...
                    </div>
                :
                    <div>
                        
                        <div
                            className="homePagamentoRiga"
                            onClick={() => {
                                props.setOpzioniPagina("conQuoteUnite");
                                props.setPagina(props.PAGINE.creditori);
                            }}
                        >
                            <span className="homePagamentoTitolo">
                                Creditori
                            </span>

                            <div className="homePagamentoBadgeContainer">
                                <span
                                    className={`homePagamentoBadge ${
                                        numeroCreditoriTot > 0
                                            ? "homePagamentoBadge-allarme"
                                            : "homePagamentoBadge-ok"
                                    }`}
                                    title="Totale quote"
                                >
                                    TOT <b>{numeroCreditoriTot}</b>
                                </span>

                                <span
                                    className={`homePagamentoBadge ${
                                        numeroCreditoriQAss > 0
                                            ? "homePagamentoBadge-allarme"
                                            : "homePagamentoBadge-ok"
                                    }`}
                                    title="Quote associative"
                                >
                                    ASS <b>{numeroCreditoriQAss}</b>
                                </span>

                                <span
                                    className={`homePagamentoBadge ${
                                        numeroCreditoriQAbb > 0
                                            ? "homePagamentoBadge-allarme"
                                            : "homePagamentoBadge-ok"
                                    }`}
                                    title="Quote abbonamento"
                                >
                                    ABB <b>{numeroCreditoriQAbb}</b>
                                </span>
                            </div>
                        </div>

                        <div
                            className="homePagamentoRiga"
                            onClick={() => {
                                props.setOpzioniPagina("conQuoteUnite");
                                props.setPagina(props.PAGINE.insolventi);
                            }}
                        >
                            <span className="homePagamentoTitolo">
                                Insolventi
                            </span>

                            <div className="homePagamentoBadgeContainer">
                                <span
                                    className={`homePagamentoBadge ${
                                        numeroInsolventiTot > 0
                                            ? "homePagamentoBadge-allarme"
                                            : "homePagamentoBadge-ok"
                                    }`}
                                    title="Totale quote"
                                >
                                    TOT <b>{numeroInsolventiTot}</b>
                                </span>

                                <span
                                    className={`homePagamentoBadge ${
                                        numeroInsolventiQAss > 0
                                            ? "homePagamentoBadge-allarme"
                                            : "homePagamentoBadge-ok"
                                    }`}
                                    title="Quote associative"
                                >
                                    ASS <b>{numeroInsolventiQAss}</b>
                                </span>

                                <span
                                    className={`homePagamentoBadge ${
                                        numeroInsolventiQAbb > 0
                                            ? "homePagamentoBadge-allarme"
                                            : "homePagamentoBadge-ok"
                                    }`}
                                    title="Quote abbonamento"
                                >
                                    ABB <b>{numeroInsolventiQAbb}</b>
                                </span>
                            </div>
                        </div>

                    </div>
                }

            </HomeCard>
        );
    }

    function scaricaDati() {
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({op:"home", emak:props.emak, sessionId: props.sessionId})
        };
    
        fetch(Parametri("serverURL", props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {          
                if(valoreDiRitorno.risultatoOperazione===1){
                    if (valoreDiRitorno.numero_iscritti !== undefined) {
                        
                        setFlagDatiDocumenti(true);
                        setNumeroIscritti(valoreDiRitorno.numero_iscritti);
                        setDocumentiCertScaduti(valoreDiRitorno.num_cert_medico_scaduti);
                        setDocumentiCertScadenza(valoreDiRitorno.num_cert_medico_scadenza);
                        setDocumentiDocIdScaduti(valoreDiRitorno.num_doc_identita_scaduti);
                        setDocumentiDocIdScadenza(valoreDiRitorno.num_doc_identita_scadenza);
                        setDocumentiPrivacyScaduti(valoreDiRitorno.num_doc_privacy_scaduti);
                        setDocumentiPrivacyScadenza(valoreDiRitorno.num_doc_privacy_scadenza);
                        
                        setFlagDatiAdempimenti(true);
                        setAdempimentiScaduti(valoreDiRitorno.num_adempimenti_scaduti);
                        setAdempimentiScadenza(valoreDiRitorno.num_adempimenti_scadenza);

                        setFlagDatiAzioniCRM(true);
                        setAzioniCRMScaduti(valoreDiRitorno.num_azioniCRM_scaduti);
                        setAzioniCRMScadenza(valoreDiRitorno.num_azioniCRM_scadenza);

                        setFlagDatiPagamenti(true);
                        setNumSpesePagare(valoreDiRitorno.num_spese_pagare);
                        setNumRimborsiPagare(valoreDiRitorno.num_rimborsi_pagare);

                        setDimensioneDatabaseMB(valoreDiRitorno.dimensione_database_mb);
                        setDimensioneAllegatiMB(valoreDiRitorno.dimensione_allegati_mb);

                        setGiorniValiditaAbbonamento(valoreDiRitorno.giorni_validita_abbonamento);
                        setLimiteMB(valoreDiRitorno.limite_mb)
                        setLimiteIscritti(valoreDiRitorno.limite_iscritti)

                        setSuggerimenti(valoreDiRitorno.suggerimenti)

                        if (valoreDiRitorno.giorni_validita_abbonamento<0) {
                            if (valoreDiRitorno.giorni_validita_abbonamento < 0) {
                                alert(
                                    "Abbonamento scaduto.\n\n" +
                                    "Il servizio potrebbe subire limitazioni.\n\n" +
                                    "Rinnova da Impostazioni → Mio Abbonamento " +
                                    "o contatta l’assistenza per il rinnovo."
                                );
                            }
                        }
                        if (valoreDiRitorno.giorni_validita_abbonamento>=0) props.setStatoAbbonamentoGestioneSportiva("ATTIVO");
                        if (valoreDiRitorno.giorni_validita_abbonamento<0 && valoreDiRitorno.giorni_validita_abbonamento>-15) props.setStatoAbbonamentoGestioneSportiva("APPENA_SCADUTO");
                        if (valoreDiRitorno.giorni_validita_abbonamento<-15) props.setStatoAbbonamentoGestioneSportiva("SCADUTO");

                        setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
                    }
                }
                if(valoreDiRitorno.risultatoOperazione===2) {
                    console.log("errore scaricamento dati da " + Parametri("serverURL",props.identitaSelezionata));
                    props.setPagina(props.PAGINE.tornaLogin);
                }
          },
          (error) => {console.log("Errore fetch");}
        );        
    }

    return (
        <Fragment>
            {statoPagina === STATO_MEMORIZZAZIONE ? <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
                <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}><Clessidra loading={true}/>
                </div>
                </div> :""}
            {statoPagina === STATO_ERRORE_CONNESSIONE ? <div>Errore: 1HM {error.message}</div> :""}
            {statoPagina === STATO_OPERAZIONE_FALLITA ? <div>Errore per operazione errata</div> :""}

            {/*{statoPagina === STATO_VAI_IN_FAQ? 
                <div>
                <Suspense fallback={
                <div className="loader-container">
                <div className="loader-container-inner"><h6 className="mt-5">Caricamento FAQ in corso...</h6></div>
                </div>
            }>

            <TabellaFaq 
                {...props} 
                callbackTermineVisualizzaFaq={callbackTermineVisualizzaFaq} 
                >
            </TabellaFaq>
            </Suspense>
            </div>
        :""}      */}
        
        {statoPagina === STATO_RICERCA_DATI_CORRETTA ?
            <div className='schedaContenitore' style={{height:props.dimensioniApp.yMain}}>
                <div className="schedaSpazioCentrale" style={{display:"flex", flexDirection:"column"}}>

                    {formAiuto === true ?
                            <Modale 
                            larghezza = 'lg'
                            titolo="Richiesta di assistenza"
                            flagErrore={true}
                            contenuto={<div>
                                <Row form>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label for="problema">Descrivi nei dettagli il problema così potremo aiutarti</Label>
                                            <Input type="textarea" cols="100" rows="20" name="problema" id="problema" innerRef={problema} placeholder= "" defaultValue= ""/>
                                        </FormGroup>
                                    </Col>
                                </Row>  
                            </div>}
                            bottoni={[
                                {
                                    "etichetta":"Invia la richiesta",
                                    "tipo":"success",
                                    callback:() => {tornaHome();fetchRichiestaAiuto()}
                                },
                                {
                                    "etichetta":"Indietro",
                                    "tipo":"primary",
                                    callback:() => {tornaHome()}
                                },
                            ]}
                        />
                    :""}

                    {problemaNonSpecificato === true ?
                            <Modale 
                            titolo="Informativa su Richiesta di assistenza"
                            flagErrore={true}
                            contenuto={<div>Il problema non è stato specificato</div>}
                            bottoni={[
                                {
                                    "etichetta":"Ok",
                                    "tipo":"primary",
                                    callback:() => {tornaHome()},
                                }    
                            ]}
                        />
                    :""}

                    {richiestaAiutoFallita === true ?
                        <Modale 
                            titolo="Informativa su Richiesta di assistenza"
                            flagErrore={true}
                            contenuto={<div>La richiesta non è andata a buon fine</div>}
                            bottoni={[
                                {
                                    "etichetta":"Ok",
                                    "tipo":"primary",
                                    callback:() => {tornaHome(false)},
                                }    
                            ]}
                        />
                    :""}

                    {richiestaAiutoInviata=== true ?
                        <Modale 
                            titolo="Informativa su Richiesta di assistenza"
                            flagErrore={true}
                            contenuto={<div>La richiesta è stata inviata correttamente. Riceverai quanto prima una risposta all'indirizzo {mailRichiedenteAiuto}</div>}
                            bottoni={[
                                {
                                    "etichetta":"Ok",
                                    "tipo":"primary",
                                    callback:() => {tornaHome(false)},
                                }    
                            ]}
                        />
                    :""}


                    <div className="homeDashboard">

                        <Benvenuto {...props}/>
                        <AlertAbbonamentoScaduto />                        

                        {props.identitaSelezionata.flag_amministrazione === 1 ?
                            <div className="homeGrid">

                                <DocumentiScadenze {...props}/>
                                <PagamentiScadenze {...props}/>
                                <AdempimentiScadenze {...props}/>
                                <Aiuto {...props}/>

                            </div>
                        :
                            props.identitaSelezionata.flag_staff === 1 ?
                                <div className="homeGrid">
                                    <Aiuto {...props}/>
                                </div>
                            :
                                null
                        }

                    </div>

                </div>
            </div>
            :""}
        </Fragment>
    );


}
export default Home;
